import { teceoLightGray } from '../../../Theme';

interface IGetColorStyle {
  isImage?: boolean;
  hexcode?: string;
  imageUrl?: string;
}

export const getColorStyle = ({ isImage, hexcode, imageUrl }: IGetColorStyle) => {
  const mustUseImageUrl = (isImage && imageUrl) || (!hexcode && imageUrl);
  return mustUseImageUrl
    ? { backgroundImage: `url(${encodeURI(decodeURI(imageUrl))})`, backgroundSize: 'cover' }
    : { backgroundColor: hexcode || teceoLightGray };
};
